import {
  FIELDALLOWANCEREQUESTORDER_ALL,
  FIELDALLOWANCEREQUESTORDER_GET,
  FIELDALLOWANCEREQUESTORDER_DEL,
  FIELDALLOWANCEREQUESTORDER_PUT,
  FIELDALLOWANCEREQUESTORDER_POST,
  FIELDALLOWANCEREQUESTORDER_LOADING,
  FIELDALLOWANCEREQUESTORDER_ERROR,
  FIELDALLOWANCEREQUESTORDER_PENDING_COUNT,
} from '../types';

import api from '../../../utils/functions/api';

export const fieldAllowanceRequestOrderCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: FIELDALLOWANCEREQUESTORDER_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/field-allowance-request-order`,
      { ...payload },
    );
    dispatch({ type: FIELDALLOWANCEREQUESTORDER_POST, payload: data });
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: FIELDALLOWANCEREQUESTORDER_ERROR });
    throw error;
  }
};

export const fieldAllowanceRequestOrderAll = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: FIELDALLOWANCEREQUESTORDER_LOADING });
    const { size = 999999, page = 1, me = '' } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/field-allowance-request-order?size=${size}&page=${page}&me=${me}`,
    );
    if (status === 200) {
      dispatch({ type: FIELDALLOWANCEREQUESTORDER_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: FIELDALLOWANCEREQUESTORDER_ERROR });
    throw new Error(error);
  }
};

export const fieldAllowanceRequestOrderGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/field-allowance-request-order/${id}`,
    );
    if (status === 200) {
      dispatch({ type: FIELDALLOWANCEREQUESTORDER_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: FIELDALLOWANCEREQUESTORDER_ERROR });
    throw new Error(error);
  }
};

export const fieldAllowanceRequestOrderPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: FIELDALLOWANCEREQUESTORDER_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/field-allowance-request-order/${id}`,
      payload,
    );
    dispatch({ type: FIELDALLOWANCEREQUESTORDER_PUT, payload: data });
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: FIELDALLOWANCEREQUESTORDER_ERROR });
    throw new Error(error);
  }
};

export const fieldAllowanceRequestOrderDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: FIELDALLOWANCEREQUESTORDER_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/field-allowance-request-order/${id}`,
    );
    dispatch({ type: FIELDALLOWANCEREQUESTORDER_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: FIELDALLOWANCEREQUESTORDER_ERROR });
    throw new Error('เกิดข้อผิดพลาด');
  }
};

export const fieldAllowanceRequestOrderPendingCount = () => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/field-allowance-request-order?status=PENDING&size=1&page=1`,
    );
    if (status === 200) {
      const count = data?.total ?? data?.rows?.length ?? 0;
      dispatch({ type: FIELDALLOWANCEREQUESTORDER_PENDING_COUNT, payload: count });
    }
  } catch (error) {
    console.error(error);
  }
};
